<template>
    <i v-show="showIcon" :class="iconClass"></i>
</template>

<script setup>
import { computed } from 'vue';


    const props = defineProps({
        showIcon: {
            type: Boolean,
            default: true
        },
        type: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: ''
        }
    });
    const iconClass = computed(() => `${props.type} ${props.type}-${props.icon}`);
</script>